import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';

const SelectInput = ({ formik, label, name, options }) => {
    return (
        <FormControl fullWidth error={formik.touched[name] && !!formik.errors[name]}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-label`}
                id={name}
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label={label}
            >
                {options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>
                {formik.touched[name] && formik.errors[name] ? formik.errors[name] : ""}
            </FormHelperText>
        </FormControl>
    );
};

export default SelectInput;


